import React from 'react';

const Logo = ({ className = "w-10 h-10" }) => (
  <img 
    src="https://media-manager-c.questera.ai/greta-media/8a70ca51af2d25ce7a8315899c53350503072ac0455482e7876f24d86c3df87814a475346bbe14751261db5845097a6d/images/aW1hZ2UvcG5n/f5d2b8183269e4a7399348387d6b0933.png" 
    alt="Pulse5 Logo" 
    className={`${className} object-contain rounded-full shadow-sm transition-all duration-200`} 
  />
);

export default Logo;